import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../environment';
import { HttpProvider } from '../../providers/http/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { CustomerProvider } from '../../providers/customer/customer';
import { TranslateService } from '@ngx-translate/core';
import { ZendeskTagsType } from '../../model/types/zendesk-tags-type';
import { ZendeskRequestType } from '../../model/types/zendesk-request-type';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';


@Injectable()
export class ZendeskSupportProvider {

  constructor(
    private httpProvider: HttpProvider,
    private loadingProvider: LoadingProvider,
    private translate: TranslateService,
    private customerProvider: CustomerProvider,
  ) {
  }

  public async createZendeskTicket(zendeskParams: any) {
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/zendesk/ticket`, {
      requestType: zendeskParams.requestType,
      subject: zendeskParams.subject,
      comment: zendeskParams.comment,
      customerEmail: zendeskParams.customerEmail,
      tags: zendeskParams.tags
    })
    if (response && response.Result && response.Result.RetVal === 1)
      return response.Result.RetMsg;
    else 
      return null;
  }

  async requestSupport(routeProvider, viewCtrl, onHoldTypes) {
    try {
      this.loadingProvider.show();
      const customer = await this.customerProvider.getCustomer();
      if (customer.emailAddress) {
        const params = {
          requestType: ZendeskRequestType.Ticket,
          subject: "Customer on Hold - User requests to be re-enabled",
          comment: "Customer on hold type:" + onHoldTypes,
          customerEmail: this.customerProvider.customer.emailAddress,
          tags: [
            ZendeskTagsType.CustomerOnHold
          ],
        }
        const zendeskRes = await this.createZendeskTicket(params);

        if (!zendeskRes) {
          RmtPopupComponent.showErrorWithLogTranslation('global.errorGeneralMessage');
          this.loadingProvider.hide();
          return;
        }

        if(routeProvider.hasPage(routeProvider.pages.TabsHomeActivityPage, true))
          viewCtrl.dismiss();
        await routeProvider.setRoot(routeProvider.pages.TabsHomeActivityPage);
        routeProvider.openActionSheet(routeProvider.pages.ModalAlertPage, {
          image: 'assets/imgs/thumbs_up_large.svg',
          title: this.translate.instant('page.customerOnHoldPage.requestReceivedTitle'),
          subtitle: this.translate.instant('page.customerOnHoldPage.requestReceivedText'),
          primaryButtonText: this.translate.instant('global.gotItButton'),
          primaryAction: () => viewCtrl.dismiss(),

        }, null);
        this.loadingProvider.hide();
        return;
      } else {
        // Customer email address not found
        this.loadingProvider.hide();
        routeProvider.openActionSheet(routeProvider.pages.EmailUpdatePage,{
          onHoldTypes
      },
        null,
      );
      }
    } catch (ex) {
      RmtPopupComponent.showErrorWithLogTranslation('global.errorGeneralMessage');
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Exception during creating zendesk ticket');
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/zendesk/zendesk-support.ts